import { FC } from "react";

import Container from "@/components/base/container";
import { Pagination } from "components/base/pagination";
import { BlogPostI } from "@/interfaces/strapi/collection-types";
import { StrapiPaginationI } from "@/interfaces/strapi/pagination";
import { MoreSalesQualifiedMeetingsCTA } from "components/base/sections/call-to-action";
import Router from "@/helpers/router";
import { BlogPostCard } from "@/components/base/cms/blog-post-card";
import { BackgroundShape } from "shared/ui/background-shape";
import { BACKGROUND_SHAPES } from "shared/ui/background-shape/constants";
import { clsxMerge } from "shared/lib/helpers";

interface BlogModulePropsI {
  posts?: BlogPostI[];
  pagination?: StrapiPaginationI;
}

export const BlogModule: FC<BlogModulePropsI> = ({ posts, pagination }) => (
  <article>
    <Container>
      <div className="relative">
        <h1
          className={clsxMerge(
            "mb-5 max-w-[500px] typography-header-5-semibold",
            "sm:typography-header-3",
            "lg:typography-header-2 xl:max-w-full"
          )}
        >
          Sales is ever evolving.
        </h1>
        <h2 className="mb-20 max-w-[549px] typography-header-7">
          From Glencoco community updates to best practice and new approaches in
          sales, we’ve got you covered.
        </h2>

        <BackgroundShape
          shape={BACKGROUND_SHAPES.FIGURE_1}
          className="-right-6 hidden blur-[60px] md:top-10 md:block lg:right-20 lg:top-14"
          imageClassName="w-[343px]"
        />
      </div>

      <section className="relative grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {posts?.map((post, i) => (
          <BlogPostCard key={i} {...post} />
        ))}

        <BackgroundShape
          shape={BACKGROUND_SHAPES.FIGURE_1}
          className={clsxMerge(
            "right-0 top-[400px] blur-[80px]",
            "lg:left-1/2 lg:-translate-x-1/2"
          )}
          imageClassName="w-[460px]"
        />

        <BackgroundShape
          className="-bottom-[320px] left-1/2 w-[820px] -translate-x-1/2 blur-[60px] lg:blur-none"
          imageClassName="rotate-[196deg]"
          shape={BACKGROUND_SHAPES.FIGURE_1}
        />
      </section>

      {pagination && (
        <Pagination
          className="mt-8 flex justify-center"
          current={pagination.page - 1}
          total={pagination.pageCount}
          baseHref={Router.blog()}
        />
      )}
    </Container>

    <MoreSalesQualifiedMeetingsCTA className="mt-[260px] md:mt-[400px]" />
  </article>
);
